import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _slicedToArray from '@babel/runtime-corejs3/helpers/slicedToArray';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _mapInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/map';
import React__default, { forwardRef, useRef, useState, useEffect } from 'react';
import classNames from 'classnames';
import styles from './48404219cb10939c86e5daacfa7d535fffaba81d8e00b9fd9aab9f417871c5f2.cfe-internal.js';
import { useToolbarContext, ToolbarProvider } from './a160cf879b7cab120bf814e64f156f70cee237e5ec6d1ada4eef9b879e36d9b6.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import '../IconButton/fa92464f43077b1cbdd0bb416ee549d83eadaee9906eab0987bbf0ad889eddad.cfe-internal.js';
import '../../icons/index.es.js';
import IconButtonWithLabel from './605bf36628a11924ba248af52d9933a9c308ca46be92fc848a17faf3182e87be.cfe-internal.js';
import '../../hooks/8930fff059088aae845742b95b03a9c78f1349f3c58d1781f854d37c28181edd.cfe-internal.js';
import useTranslation from '../../utils/Translation/de13cef5749fcd5a6a2788a56fd20c6a15d546ad2713851a9b628cd5aa481529.cfe-internal.js';
import useControllableState from '../../hooks/useControllableState/fc7c2512fc1249f4837f2cb1f271d18191fa6aebd32c5f03023614c2b76711ef.cfe-internal.js';
import IconButton from '../IconButton/399631eebecc03da030561fb1a25c35c2d29c5e4645700b7fca3cf592ca75904.cfe-internal.js';
import getSubDataTestId from '../../utils/getSubDataTestId/d234b5cba8708c34be51c9bf4976cdee0c55fe33ce1598dbff38a5cf644e53a8.cfe-internal.js';
import ChevronRightIcon from '../../icons/components/88a8116bd7f81fb87e1ae07d2c7a465dd4392543779b5970a2459038f6173e7a.cfe-internal.js';
import ChevronLeftIcon from '../../icons/components/4be65fa2c37c7c5ad2b1119dd9a3ebbad592dd6c1add59bde867d96dd5145c7a.cfe-internal.js';
import mergeRefs from '../../utils/mergeRefs/836dcb860bec00d9c59bd64df8df6df42430840bc5bfc21b6000935baefbeacd.cfe-internal.js';

var _excluded = ["isCollapsible", "defaultIsCollapsed", "isCollapsed", "onIsCollapsedChange", "children", "className", "aria-label", "aria-labelledby", "aria-describedby"];
var ToolbarTabs = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _context;
  var _ref$isCollapsible = _ref.isCollapsible,
    isCollapsible = _ref$isCollapsible === void 0 ? true : _ref$isCollapsible,
    _ref$defaultIsCollaps = _ref.defaultIsCollapsed,
    defaultIsCollapsed = _ref$defaultIsCollaps === void 0 ? false : _ref$defaultIsCollaps,
    externalIsCollapsed = _ref.isCollapsed,
    onIsCollapsedChange = _ref.onIsCollapsedChange,
    children = _ref.children,
    className = _ref.className,
    ariaLabel = _ref['aria-label'],
    ariaLabelledBy = _ref['aria-labelledby'],
    ariaDescribedBy = _ref['aria-describedby'],
    rest = _objectWithoutProperties(_ref, _excluded);
  var _useTranslation = useTranslation(),
    translate = _useTranslation.translate;
  var tabRefs = useRef({});
  var expandToolbarTabsIconButtonRef = useRef(null);
  var collapseToolbarTabsIconButtonWithLabelRef = useRef(null);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpandCollapseButtonFocused = _useState2[0],
    setIsExpandCollapseButtonFocused = _useState2[1];
  var _useControllableState = useControllableState(isCollapsible && defaultIsCollapsed, isCollapsible ? onIsCollapsedChange : undefined, isCollapsible && externalIsCollapsed),
    _useControllableState2 = _slicedToArray(_useControllableState, 2),
    isCollapsed = _useControllableState2[0],
    setIsCollapsed = _useControllableState2[1];

  /*
   * Focuses the new expand/collapse button when the tabs expand/collapse and the old expand/collapse button was focused.
   * When the tabs expand/collapse, a different expand/collapse button is rendered, which is why the programmatic focus is needed.
   */
  useEffect(function () {
    if (isExpandCollapseButtonFocused) {
      if (isCollapsed) {
        var _expandToolbarTabsIco;
        (_expandToolbarTabsIco = expandToolbarTabsIconButtonRef.current) === null || _expandToolbarTabsIco === void 0 || _expandToolbarTabsIco.focus();
      } else {
        var _collapseToolbarTabsI;
        (_collapseToolbarTabsI = collapseToolbarTabsIconButtonWithLabelRef.current) === null || _collapseToolbarTabsI === void 0 || _collapseToolbarTabsI.focus();
      }
    }
  }, [isCollapsed, isExpandCollapseButtonFocused]);
  var _useToolbarContext = useToolbarContext(),
    selectedIndex = _useToolbarContext.selectedIndex,
    setSelectedIndex = _useToolbarContext.setSelectedIndex,
    id = _useToolbarContext.id,
    rootDataTestId = _useToolbarContext.rootDataTestId;
  var _useState3 = useState(selectedIndex),
    _useState4 = _slicedToArray(_useState3, 2),
    focusedIndex = _useState4[0],
    setFocusedIndex = _useState4[1];
  var numTabs = React__default.Children.count(children);
  var focusTab = function focusTab(index) {
    var _tabRefs$current;
    (_tabRefs$current = tabRefs.current) === null || _tabRefs$current === void 0 || (_tabRefs$current = _tabRefs$current[index]) === null || _tabRefs$current === void 0 || _tabRefs$current.focus();
    setFocusedIndex(index);
  };

  /*
   * Sets the focused index back to the currently selected tab.
   * This makes sure that when the user tabs back into the tablist, the focus is set on the currently selected tab.
   */
  var handleTabListBlur = function handleTabListBlur() {
    setFocusedIndex(selectedIndex);
  };
  var expandCollapseButton;
  var expandCollapseButtonDataTestIdSuffix = 'tabs-expand-collapse-button';
  if (isCollapsible) {
    if (isCollapsed) {
      var expandToolbarTabsLabel = translate('showLabels');
      expandCollapseButton = /*#__PURE__*/React__default.createElement(IconButton, {
        className: classNames(styles.toolbarTab, styles.toolbarTabIconButton, styles.tabsExpandCollapseButton),
        "aria-label": expandToolbarTabsLabel,
        tooltipContent: expandToolbarTabsLabel,
        tooltipPlacement: "right",
        onClick: function onClick() {
          return setIsCollapsed(false);
        },
        onFocus: function onFocus() {
          return setIsExpandCollapseButtonFocused(true);
        },
        onBlur: function onBlur() {
          return setIsExpandCollapseButtonFocused(false);
        },
        ref: expandToolbarTabsIconButtonRef,
        "aria-pressed": false,
        "data-testid": getSubDataTestId(rootDataTestId, expandCollapseButtonDataTestIdSuffix)
      }, /*#__PURE__*/React__default.createElement(ChevronRightIcon, {
        className: styles.icon,
        "aria-hidden": "true"
      }));
    } else {
      expandCollapseButton = /*#__PURE__*/React__default.createElement(IconButtonWithLabel, {
        className: classNames(styles.toolbarTab, styles.tabsExpandCollapseButton),
        icon: ChevronLeftIcon,
        label: translate('hideLabels'),
        onClick: function onClick() {
          return setIsCollapsed(true);
        },
        onFocus: function onFocus() {
          return setIsExpandCollapseButtonFocused(true);
        },
        onBlur: function onBlur() {
          return setIsExpandCollapseButtonFocused(false);
        },
        ref: collapseToolbarTabsIconButtonWithLabelRef
        /* eslint-disable-next-line react/jsx-boolean-value */,
        "aria-pressed": true,
        "data-testid": getSubDataTestId(rootDataTestId, expandCollapseButtonDataTestIdSuffix)
      });
    }
  }
  return /*#__PURE__*/React__default.createElement("div", _extends({}, rest, {
    className: classNames(className, styles.toolbarNav, _defineProperty({}, styles.toolbarNavCollapsed, isCollapsed)),
    ref: ref
  }), /*#__PURE__*/React__default.createElement("div", {
    role: "tablist",
    "aria-orientation": "vertical",
    className: styles.toolbarTabs,
    onBlur: handleTabListBlur,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy,
    "aria-describedby": ariaDescribedBy
  }, _mapInstanceProperty(_context = React__default.Children).call(_context, children, function (child, index) {
    return /*#__PURE__*/React__default.createElement(ToolbarProvider, {
      value: {
        focusedIndex: focusedIndex,
        selectedIndex: selectedIndex,
        setSelectedIndex: setSelectedIndex,
        focusTab: focusTab,
        isCollapsed: isCollapsed,
        numTabs: numTabs,
        index: index,
        id: id,
        rootDataTestId: rootDataTestId
      }
    }, /*#__PURE__*/React__default.cloneElement(child, {
      ref: mergeRefs(child.ref, function (node) {
        tabRefs.current[index] = node;
      })
    }));
  })), expandCollapseButton);
});

export { ToolbarTabs as default };
